import { FC } from 'react';
import { getStartedItems } from './constants';
import { Image } from 'components/Image';
import { ENV_CONFIG } from 'config/environment';

interface Props {
  items: typeof getStartedItems;
  title: string;
  subtitle?: string;
  backup?: boolean;
}

export const Marketing: FC<Props> = ({ items, title, subtitle, backup }) => {
  return (
    <div className="marketing-container">
      <span className="h2-dtm">{title}</span>
      {subtitle && <span className="h4-text">{subtitle}</span>}
      <div className="get-started-items">
        {items.map(item => (
          <div className="get-started-item" key={item.id}>
            {backup &&
              (item.image ? (
                <Image
                  className="styled-image"
                  alt={item.title}
                  src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/${
                    item.image
                  }.png`}
                />
              ) : (
                <Image
                  className="styled-image"
                  alt={item.title}
                  src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/getstarted/NoSpam.png`}
                />
              ))}
            <div className="get-started-texts">
              <span className="h3-dtm color-oathBlue">{item.title}</span>
              <span className="h4-text">{item.subtitle}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
